<mat-card appearance="outlined" class="flex flex-col mt-medium p-medium w-full">
    <div class="evida-error max-w-780px mx-auto flex flex-col w-full md:flex-row">
        <div class="md:w-2/12 w-full text-center sm:text-left">
            <mat-icon [svgIcon]="icon" class="evida-error__image"></mat-icon>
        </div>
        <div class="md:w-10/12 md:pl-20px w-full">
            <div class="evida-error__content">
                <ng-content></ng-content>
                @if (errorCode) {
                    <p class="evida-error__content__errorCode">
                        Fejlkode: <code class="selectAll">{{ errorCode }}</code>
                        <br />
                        <br />
                    </p>
                }
            </div>
           @if (showCorrelationId) {
                <div class="flex flex-col">
                    @if (correlationId) {
                        <span translate="shared.errormessages.correlationId"></span>
                        <code>{{ correlationId }}</code>
                        <app-evida-button class="mt-5px" type="secondary_no_border" (clicked)="onCopyCorrelationId()">
                            {{ 'shared.buttons.copyToClipboard' | translate }}
                        </app-evida-button>
                        <span class="mt-medium">{{
                            'shared.errormessages.date' | translate: { date: errorDate?.date }
                        }}</span>
                        <span>{{ 'shared.errormessages.component' | translate }}</span>
                    }
                </div>
            }
            @if (showRetryButton || showCancelButton || showLogoutButton) {
                <mat-card-footer>
                    <div class="flex w-full flex-col-reverse sm:flex-row justify-between">
                        <div class="mb10">
                            @if (showCancelButton) {
                                <app-evida-button
                                    type="secondary"
                                    (clicked)="secondaryButtonClicked()"
                                    class="evida-error__cancelButton"
                                >
                                    {{ cancelButtonText | translate }}
                                </app-evida-button>
                            }
                        </div>
                        <div class="flex flex-row justify-end">
                            @if (showLogoutButton) {
                                <div class="mb10 mr-10px">
                                    <app-evida-button
                                        type="secondary_no_border"
                                        (clicked)="logoutButtonClicked()"
                                        class="evida-error__logoutbutton"
                                    >
                                        {{ logoutButtonText | translate }}
                                    </app-evida-button>
                                </div>
                            }
                            @if (showRetryButton) {
                                <div class="mb10">
                                    <app-evida-button
                                        type="primary"
                                        (clicked)="primaryButtonClicked()"
                                        class="evida-error__retrybutton"
                                    >
                                        {{ retryButtonText | translate }}
                                    </app-evida-button>
                                </div>
                            }
                        </div>
                    </div>
                </mat-card-footer>
            }
        </div>
    </div>
</mat-card>